/** Minimal shape so partial DTOs (e.g. refill ``RequestedPrescription``) work. */
export interface RenewalBadgeInput {
  readonly IsRxRenewal?: boolean | null;
  readonly RxRenewalNote?: string | null;
}

export interface RenewalBadge {
  readonly show: boolean;
  readonly note: string | null;
  readonly label: 'Renewal';
}

export function buildRenewalBadge(
  prescription: RenewalBadgeInput | null | undefined
): RenewalBadge {
  const show = prescription?.IsRxRenewal === true;
  const note = prescription?.RxRenewalNote?.trim() || null;
  return { show, note, label: 'Renewal' };
}
